var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4915 23.2191C27.057 24.6536 24.1344 24.6 22.773 23.2385C21.2849 21.7505 21.535 17.4477 21.6411 14.8719L8.76197 27.7511C6.39196 30.1211 5.26407 30.5524 3.81623 30.2272C3.12397 30.0963 2.36648 29.6507 1.6066 28.8908C0.0868496 27.371 -0.112183 25.987 0.47412 24.5775C0.783101 23.8886 1.56128 22.9204 2.74629 21.7354L15.6255 8.85625L12.6093 8.89619C10.9441 8.91497 9.7496 8.84306 8.99402 8.6488C8.23843 8.45454 7.67044 8.13601 7.25884 7.72441C5.92906 6.39463 5.8126 3.47158 7.27827 2.00591C8.12025 1.16393 9.49952 0.734508 12.0445 0.722406L29.8909 0.60651L29.7721 18.0758C29.7317 21.029 29.3646 22.346 28.4915 23.2191Z",
    fill: "#F9F5EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpright);
export default __webpack_public_path__ + "static/media/upright.ad81a5635e65f359a0a06817ffb5d019.svg";
export { ForwardRef as ReactComponent };